import { render, staticRenderFns } from "./monitoring6Detail.vue?vue&type=template&id=953824c0"
import script from "./monitoring6Detail.vue?vue&type=script&lang=js"
export * from "./monitoring6Detail.vue?vue&type=script&lang=js"
import style0 from "./monitoring6Detail.vue?vue&type=style&index=0&id=953824c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports